/**
 * „Regelwerke“ — die Pflichtenprüfung für Fachprüfer mit Plattformrolle (Recht / FM).
 *
 * Fachprüfer können zu beliebigen Mandanten gehören; das Regelwerk selbst gehört der Plattform.
 * Die Seite zeigt deshalb nur Prüfliste, Änderungsprüfung und Regelwerke der Betreiberverantwortung
 * (dieselben Bausteine wie in der Administration) und ist ohne Plattformrolle leer.
 */

import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";

import type { AppShellContext } from "../components/AppShell";
import ContentPanel from "../components/ContentPanel";
import OperatorResponsibilityPanel from "../administration/operator-responsibility/OperatorResponsibilityPanel";
import { myPlatformRolesAtom } from "../PlatformRolesAPI";

export default function RulebookPage() {
  const { t } = useTranslation();
  const { setTitle } = useOutletContext<AppShellContext>();
  const [myPlatformRoles] = useAtom(myPlatformRolesAtom);

  useEffect(() => {
    setTitle(t("rulebookPage.title"));
  }, [setTitle, t]);

  return (
    // Wie Dashboard und Administration: der Grund kommt von der Shell, nicht aus der Kundenfarbe.
    <ContentPanel backgroundColor="transparent">
      {myPlatformRoles === undefined ? null : myPlatformRoles.length === 0 ? (
        <p className="min-w-0 break-words text-sm text-muted-foreground">{t("rulebookPage.noRole")}</p>
      ) : (
        <OperatorResponsibilityPanel scope="rulebook" />
      )}
    </ContentPanel>
  );
}
